import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ScrollToTop = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const unlisten = () => {
      // 这里可以根据需要进行一些条件判断，以确定是否滚动到顶部
      window.scrollTo(0, 0);
    };

    return () => {
      unlisten();
    };
  }, [navigate]);

  return null;
};

export default ScrollToTop;
